import { assertClientDocumentV2 } from './quoteDocumentV2Contract';

// Maps a client-only B5 document to the existing ICC HTML shell. No backend
// version/result enters this module. The calculation object only carries certified totals.
export const documentV2RenderContext = (source) => {
  const document = assertClientDocumentV2(source);
  const { identity, version, facts, customer } = document;
  const formats = { 'PDF uniquement': 'PDF_ONLY', 'PDF + fichiers sources': 'PDF_AND_SOURCES', 'Fichiers sources uniquement': 'SOURCES_ONLY' };
  return { document,
    editor: { ...version, currencyCode: 'EUR', quoteNumber: identity.quoteNumber, versionNumber: identity.versionNumber,
      createdAt: identity.createdAt, versionStatus: 'issued', clientDocument: facts.terms, customerSnapshot: customer,
      deliveryFormatCode: formats[facts.contractTerms.deliveryFormat] || 'OTHER', deliveryFormatOther: facts.contractTerms.deliveryFormat,
      ...facts.contractTerms, versionParameters: [
        { parameterCode: 'escalationFormula', valueText: facts.contractTerms.escalationFormula },
        { parameterCode: 'revisionFormula', valueText: facts.contractTerms.revisionFormula }], options: [] },
    calculated: { totals: { totalHT: facts.totalSellingPriceHT, totalVat: facts.totalVatAmount, totalTTC: facts.totalSellingPriceTTC },
      taxBreakdown: facts.taxBreakdown, optionViews: [], clientLines: [] },
  };
};
